import { MatchContainer, MatchTeamsContainer, MatchPoints } from "./styles";
import { PickemUserMatchemMatchTeam } from "./PickemUserMatchemMatchTeam";

interface Props {
  rosterIds: string[];
  tournamentId: string;
  pickedRosterId: string | undefined;
  matchPoints: number | undefined;
}

export const PickemUserMatchemMatch = ({
  rosterIds,
  tournamentId,
  pickedRosterId,
  matchPoints,
}: Props) => {
  return (
    <MatchContainer>
      <MatchTeamsContainer>
        {rosterIds.map((id) => (
          <PickemUserMatchemMatchTeam
            key={id}
            rosterId={id}
            tournamentId={tournamentId}
            picked={pickedRosterId === id}
          />
        ))}
      </MatchTeamsContainer>
      <MatchPoints>{matchPoints ?? "-"}</MatchPoints>
    </MatchContainer>
  );
};
